import { Controller } from '@hotwired/stimulus'
import Typed from 'typed.js'

export default (class extends Controller {
  static values = {
    showCursor: { type: Boolean, default: true },
    strings: Array
  }

  connect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.element.textContent = this.stringsValue[0] || this.element.textContent
      return
    }

    this.typed = new Typed(this.element, {
      backSpeed: 15,
      backDelay: 3000,
      loop: true,
      showCursor: this.showCursorValue,
      strings: this.stringsValue,
      typeSpeed: 30
    })

    this.observer = new IntersectionObserver(
      this.#handleIntersect.bind(this),
      { root: null, rootMargin: '0px 0px -200px 0px', threshold: 0 }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.typed?.destroy()
  }

  #handleIntersect(entries) {
    entries.forEach(entry => {
      entry.isIntersecting ? this.typed.start() : this.typed.stop()
    })
  }
})
